// Design Tokens - Typography
// Use these tokens for all font-related values

export const typography = {
  // Font families
  fontFamily: {
    heading: '"Orbitron", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: '"Roboto Flex", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    sans: '"Roboto Flex", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
  },

  // Font sizes
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    md: '17px',
    lg: '19px',
    xl: '20px',
    '2xl': '24px',
    '2.5xl': '28px',
    '3xl': '30px',
    '4xl': '36px',
    '4.5xl': '40px',
    '5xl': '48px',
    '5.5xl': '56px',
    '6xl': '60px',
  },

  // Font weights
  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },

  // Line heights
  lineHeight: {
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.75',
  },

  // Letter spacing
  letterSpacing: {
    tight: '-0.05em',
    normal: '0',
    wide: '0.05em',
  },

  // Presets
  body: {
    default: {
      size: '16px',
      weight: '400',
      lineHeight: '1.5',
      fontFamily: '"Roboto Flex", sans-serif',
    },
    small: {
      size: '14px',
      weight: '400',
      lineHeight: '1.5',
      fontFamily: '"Roboto Flex", sans-serif',
    },
    large: {
      size: '19px',
      weight: '400',
      lineHeight: '1.6',
      fontFamily: '"Roboto Flex", sans-serif',
    },
  },

  heading: {
    h1: {
      size: '56px',
      weight: '700',
      lineHeight: '1.2',
      fontFamily: '"Orbitron", sans-serif',
    },
    h2: {
      size: '48px',
      weight: '700',
      lineHeight: '1.2',
      fontFamily: '"Orbitron", sans-serif',
    },
    h3: {
      size: '36px',
      weight: '700',
      lineHeight: '1.25',
      fontFamily: '"Orbitron", sans-serif',
    },
    h4: {
      size: '28px',
      weight: '600',
      lineHeight: '1.3',
      fontFamily: '"Orbitron", sans-serif',
    },
    h5: {
      size: '24px',
      weight: '600',
      lineHeight: '1.3',
      fontFamily: '"Orbitron", sans-serif',
    },
    h6: {
      size: '20px',
      weight: '600',
      lineHeight: '1.4',
      fontFamily: '"Orbitron", sans-serif',
    },
  },
} as const;
